import { IconProps } from '../iconProps';

export const Analysing = ({ fill, size }: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <defs>
        <linearGradient
          id='strokeGradient'
          x1='0%'
          y1='0%'
          x2='100%'
          y2='0%'
        >
          <stop offset='0%'>
            <animate
              attributeName='stop-color'
              values='#fafaf9;#a6a09b;#79716b'
              dur='1s'
              repeatCount='indefinite'
            />
          </stop>
          <stop offset='100%'>
            <animate
              attributeName='stop-color'
              values='#79716b;#a6a09b;#fafaf9'
              dur='1s'
              repeatCount='indefinite'
            />
          </stop>
        </linearGradient>
      </defs>
      <path
        d='M6.85063 17.0538V6.94025C6.85063 6.63142 6.95646 6.37259 7.16813 6.16375C7.37963 5.95492 7.63904 5.8505 7.94638 5.8505C8.25354 5.8505 8.51196 5.95492 8.72162 6.16375C8.93112 6.37259 9.03587 6.63142 9.03587 6.94025V17.0598C9.03587 17.3686 8.93146 17.6274 8.72263 17.8363C8.51379 18.0451 8.25504 18.1495 7.94638 18.1495C7.63904 18.1495 7.37963 18.0437 7.16813 17.832C6.95646 17.6205 6.85063 17.3611 6.85063 17.0538ZM10.9104 21.1135V2.8865C10.9104 2.57767 11.0148 2.31884 11.2236 2.11C11.4326 1.90117 11.6915 1.79675 12.0001 1.79675C12.3088 1.79675 12.5676 1.90117 12.7766 2.11C12.9855 2.31884 13.0899 2.57767 13.0899 2.8865V21.1135C13.0899 21.4223 12.9855 21.6812 12.7766 21.89C12.5676 22.0988 12.3088 22.2033 12.0001 22.2033C11.6915 22.2033 11.4326 22.0988 11.2236 21.89C11.0148 21.6812 10.9104 21.4223 10.9104 21.1135ZM2.79688 12.994V11C2.79688 10.6913 2.90271 10.4325 3.11437 10.2235C3.32587 10.0147 3.58529 9.91025 3.89262 9.91025C4.19979 9.91025 4.45821 10.0161 4.66788 10.2278C4.87738 10.4393 4.98213 10.6987 4.98213 11.006V13C4.98213 13.3087 4.87771 13.5675 4.66887 13.7765C4.46004 13.9853 4.20129 14.0898 3.89262 14.0898C3.58529 14.0898 3.32587 13.9839 3.11437 13.7723C2.90271 13.5608 2.79688 13.3013 2.79688 12.994ZM14.9584 17.0538V6.94025C14.9584 6.63142 15.0641 6.37259 15.2756 6.16375C15.4873 5.95492 15.7467 5.8505 16.0539 5.8505C16.3612 5.8505 16.6196 5.95492 16.8291 6.16375C17.0388 6.37259 17.1436 6.63142 17.1436 6.94025V17.0598C17.1436 17.3686 17.0392 17.6274 16.8304 17.8363C16.6215 18.0451 16.3627 18.1495 16.0539 18.1495C15.7467 18.1495 15.4873 18.0437 15.2756 17.832C15.0641 17.6205 14.9584 17.3611 14.9584 17.0538ZM19.0181 12.994V11C19.0181 10.6913 19.1239 10.4325 19.3354 10.2235C19.547 10.0147 19.8065 9.91025 20.1136 9.91025C20.421 9.91025 20.6794 10.0161 20.8889 10.2278C21.0985 10.4393 21.2034 10.6987 21.2034 11.006V13C21.2034 13.3087 21.099 13.5675 20.8901 13.7765C20.6813 13.9853 20.4225 14.0898 20.1136 14.0898C19.8065 14.0898 19.547 13.9839 19.3354 13.7723C19.1239 13.5608 19.0181 13.3013 19.0181 12.994Z'
        fill={fill ?? 'currentColor'}
      />
    </svg>
  );
};
